import type { AggregatedProgress } from "@jari-tools/shared";

export function DigShareProgress({ data }: { data: Record<string, unknown> | null }) {
  if (!data) return <p>Nog geen voortgang gesynchroniseerd.</p>;
  const p = data as AggregatedProgress;
  const totalScores = p.score1 + p.score2 + p.score3;
  const avg =
    totalScores > 0 ? ((p.score1 + p.score2 * 2 + p.score3 * 3) / totalScores).toFixed(1) : "—";

  return (
    <dl className="dig-progress">
      <div>
        <dt>Gedaan</dt>
        <dd>{p.doneCount}</dd>
      </div>
      <div>
        <dt>Overgeslagen</dt>
        <dd>{p.skippedCount}</dd>
      </div>
      <div>
        <dt>Snooze</dt>
        <dd>{p.snoozeCount}</dd>
      </div>
      <div>
        <dt>Actieve dagen</dt>
        <dd>{p.activeDays}</dd>
      </div>
      <div>
        <dt>Gem. score (1–3)</dt>
        <dd>{avg}</dd>
      </div>
      <div>
        <dt>Scoreverdeling</dt>
        <dd>
          1: {p.score1} · 2: {p.score2} · 3: {p.score3}
        </dd>
      </div>
    </dl>
  );
}
